// extracted by mini-css-extract-plugin
export var displayNone = "_s1-6";
export var imgContainer = "_s1-2";
export var overflowHidden = "_s1-3";
export var productInfoCardButtonContainer = "_s1-5";
export var productTitleText = "_s1-4";
export var rightArrow = "_s1-1";
export var rightArrowContainer = "_s1-0";